import { Component } from "@angular/core";
import { DashboardComponent } from "../dashboard/dashboard.component";

@Component({
  selector: "app-dashboard-page",
  imports: [DashboardComponent],
  templateUrl: "./dashboard-page.component.html",
  styles: ``,
})
export class DashboardPageComponent {
  constructor() {}
}
